/**
 * Created by Анжелика on 21.11.2017.
 */
export const MEDIA_ERR_ABORTED = 1;
export const MEDIA_ERR_NETWORK = 2;
export const MEDIA_ERR_DECODE = 3;
export const MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
export const MEDIA_ERR_ENCRYPTED = 5;


// WEBPACK FOOTER //
// ./src/constants/videoErrors.js